export default __webpack_public_path__ + "static/media/infiniwell_PMS_logo-symbol.7ddcc4e2.png";